import { AccountModel } from "./account";
import { InvitationModel } from "./invitation";

export interface UserModel {
  id: string;
  photo: any;
  name: string;
  firstName: string;
  lastName: string;
  email?: string;
  emailVerifiedAt?: string;
  phone: string;
  phoneVerifiedAt?: string;
  termsAccepted: boolean;
  active: UserStatusEnum;
  accounts: AccountModel[];
  invitations: InvitationModel[];
  createdAt: string;
  updatedAt?: string;
  languageCode?: string;
  receiveSmsAlerts: boolean;
}

export interface UserInfoModel {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
}

export enum UserStatusEnum {
	Disabled = 0,
	Active = 1,
	Pending = 2,
	Deleted = 3,
}
